import React from 'react';

const WorkOrderStep3Description = ({ formData, setFormData, formErrors, rootCauseCategories, failureModes }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <div className="step-form">
      <div className="form-section">
        <h3 className="section-title">Maintenance Description</h3>
        <div class="row">
          <div className="form-group col-md-6">
            <label htmlFor="problemDescription">Problem Description / Request Notes</label>
            <textarea
              id="problemDescription"
              name="problemDescription"
              value={formData.problemDescription}
              onChange={handleChange}
              placeholder="Describe the problem or maintenance request..."
              rows="4"
            />
          </div>
          <div className="form-group col-md-6">
            <label htmlFor="taskDescription">Maintenance Task / Activity Description</label>
            <textarea
              id="taskDescription"
              name="taskDescription"
              value={formData.taskDescription}
              onChange={handleChange}
              placeholder="Describe the maintenance task or activity to be performed..."
              rows="4"
            />
          </div>

          <div className="form-group col-md-6">
            <label htmlFor="rootCauseCategoryId">Root Cause Category (if known)</label>
            <select
              id="rootCauseCategoryId"
              name="rootCauseCategoryId"
              value={formData.rootCauseCategoryId}
              onChange={handleChange}
            >
              <option value="">Select Root Cause Category</option>
              {rootCauseCategories.map(category => (
                <option key={category.rootCauseCategoryId} value={category.rootCauseCategoryId}>
                  {category.categoryName}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group col-md-6">
            <label htmlFor="failureModeId">Failure Mode (optional)</label>
            <select
              id="failureModeId"
              name="failureModeId"
              value={formData.failureModeId}
              onChange={handleChange}
            >
              <option value="">Select Failure Mode</option>
              {failureModes.map(mode => (
                <option key={mode.failureModeId} value={mode.failureModeId}>
                  {mode.failureModeName}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="attachmentsJson">Attachments (JSON - images, manuals, checklists, reports)</label>
          <textarea
            id="attachmentsJson"
            name="attachmentsJson"
            value={formData.attachmentsJson}
            onChange={handleChange}
            placeholder='JSON array: ["url1", "url2"]'
            rows="3"
          />
          <small style={{ color: 'var(--text-secondary)', fontSize: '0.85rem' }}>
            Note: File upload functionality will be implemented separately
          </small>
        </div>
      </div>
    </div>
  );
};

export default WorkOrderStep3Description;

